// Procurement routes: RFQs, vendor quotations, suppliers, POs, price comparisons
import Suppliers from '../pages/Suppliers';
import SupplierDetails from '../pages/SupplierDetails';
import SupplierReport from '../pages/SupplierReport';
import SupplierStatement from '../pages/SupplierStatement';
import SupplierPriceList from '../pages/SupplierPriceList';
import Vendor360Profile from '../pages/Vendor360Profile';
import VendorQuotations, { VendorQuotationNewPage } from '../pages/VendorQuotations';
import VendorQuotationDetail from '../pages/VendorQuotationDetail';
import PurchaseOrders from '../pages/PurchaseOrders';
import SupplierBills from '../pages/SupplierBills';
import POReceivePanel from '../pages/POReceivePanel';
import { RFQList, RFQWorkspace } from '../pages/RFQWorkspace';
import CustomerRFQ from '../pages/CustomerRFQ';
import PriceComparison from '../pages/PriceComparison';
import ItemMaster from '../pages/ItemMaster';
import Inventory from '../pages/Inventory';

const procurementRoutes = [
  { path: '/suppliers', Component: Suppliers, withUser: true },
  { path: '/suppliers/:supplierId', Component: SupplierDetails },
  { path: '/suppliers/:id/price-list', Component: SupplierPriceList },
  { path: '/suppliers/:id/vendor-360', Component: Vendor360Profile },
  { path: '/supplier-report', Component: SupplierReport },
  { path: '/supplier-statement', Component: SupplierStatement },
  { path: '/supplier-statement/:supplierId', Component: SupplierStatement },
  { path: '/vendor-quotations', Component: VendorQuotations },
  { path: '/vendor-quotations/new', Component: VendorQuotationNewPage },
  { path: '/vendor-quotations/:id', Component: VendorQuotationDetail },
  { path: '/purchase-orders', Component: PurchaseOrders, withUser: true },
  { path: '/purchase-orders/:id/receive', Component: POReceivePanel },
  { path: '/supplier-bills', Component: SupplierBills, withUser: true },
  { path: '/rfqs', Component: RFQList },
  { path: '/rfqs/:id', Component: RFQWorkspace },
  { path: '/customer-rfqs', Component: CustomerRFQ },
  { path: '/price-comparisons', Component: PriceComparison },
  { path: '/item-master', Component: ItemMaster },
  { path: '/inventory', Component: Inventory },
];

export default procurementRoutes;
